:host {
    .ti-search-myti-lists-row {
        margin-bottom: $polaris-space-4;
    }

    .ti-search-myti-lists-form-row {
        margin-bottom: $polaris-space-2;
    }

    .ti-search-myti-lists-details {
        margin-top: 0;
        margin-bottom:$polaris-space-4;
        padding: 0;
        list-style: none !important;

        li {
            line-height: $polaris-line-height-2;
            margin-bottom: $polaris-space-1;

            &:last-child {
                margin-bottom: 0;
            }
        }

    }

    ti-search-combolist {
        display: inline-block;
    }

    .ti-search-myti-lists-action-btn {
        margin-left: $polaris-space-2;
    }

    .ti-search-myti-lists-addTags-btn {
        margin-left: $polaris-space-4;
    }

    .ti-search-myti-lists-tags {
        padding-bottom: $polaris-space-4;
        display:flex;
        flex-wrap:wrap;
        gap:$polaris-space-2;
    }

    @include mix-for-sizes-down(phone) {

        ti-button,
        ti-input,
        ti-search-combolist,
        .ti-search-myti-lists-addTags-btn {
            width: 100%;
            margin: 0;
        }

        ti-search-combolist {
            margin-bottom: $polaris-space-2;
        }

        ti-input {
            margin-bottom: $polaris-space-4;
        }

    }
}
